module.exports = __webpack_public_path__ + "img/notice.76945e20.png";